
import React, { useState } from 'react';

const Flanexus: React.FC = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('简体中文');
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 flex items-center justify-center gap-2 md:h-20 bg-[#071C74] px-4 py-4 font-medium md:flex-none md:justify-start md:p-2 md:px-3">
        <div className="sticky top-0 flex h-7 items-center justify-between md:h-20 w-full max-w-7xl mx-auto">
          <div className="adi-header-left">
            <a href="/">
              <img 
                alt="Flanexus Logo" 
                width={125} 
                height={56} 
                src="https://static.readdy.ai/image/4d7c1148f372075ad366b96364633fcd/3900b388860a5efa532a02080a385ec7.png" 
                className="h-14 w-auto"
              />
            </a>
          </div>
          <div className="hidden md:flex items-center space-x-4 text-white">
            <div className="relative">
              <div className="flex bg-white/10 backdrop-blur-sm rounded-full p-1">
                <button 
                  className="px-4 py-2 text-white bg-white/20 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap"
                  onClick={() => {
                    setSelectedLanguage('简体中文');
                    setIsLanguageDropdownOpen(false);
                  }}
                >
                  简体中文
                </button>
                <a 
                  href="/flanexus/en"
                  className="px-4 py-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap"
                >
                  English
                </a>
              </div>
            </div>

            <a 
              href="/flanexus"
              className="px-4 py-2 text-white hover:text-blue-200 transition-colors whitespace-nowrap"
            >
              炎禾智联
            </a>
            
            <a 
              href="/zh/news"
              className="px-4 py-2 text-white hover:text-blue-200 transition-colors"
            >
              资讯
            </a>
            
            <a 
              href="/zh/contact-us"
              className="px-4 py-2 border border-white rounded-full hover:bg-white hover:text-[#071C74] transition-colors text-white"
            >
              联系我们
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative min-h-[600px] bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 flex items-center"
        style={{
          backgroundImage: "url('https://public.readdy.ai/ai/img_res/bf55232ef5814455370b7b1b5dc99800.jpg')"
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-blue-800/80 to-transparent"></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/90 text-sm font-medium">
                <i className="ri-global-line w-4 h-4 flex items-center justify-center mr-2"></i>
                助力企业数字化转型
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-bold text-white leading-tight">
                技术赋能出海<br />
                <span className="text-orange-400">智联全球市场</span>
              </h1>
              
              <p className="text-xl text-white/90 leading-relaxed max-w-lg">
                炎禾智联致力于通过行业领先的数字化解决方案和对业务的深刻理解，帮助企业在日益富于挑战的环境中提升核心竞争力。
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/zh/contact-us"
                  className="bg-orange-600 text-white px-8 py-4 rounded-lg hover:bg-orange-700 transition-colors font-semibold whitespace-nowrap text-center"
                >
                  免费咨询
                </a>
                <a 
                  href="https://www.flanexus.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white hover:text-blue-900 transition-colors font-semibold whitespace-nowrap text-center"
                >
                  了解更多
                </a>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20business%20technology%20illustration%20showing%20global%20expansion%2C%20digital%20transformation%20concept%2C%20modern%20corporate%20graphics%20with%20world%20map%20connections%2C%20data%20visualization%20elements%2C%20clean%20professional%20design%20with%20blue%20and%20orange%20color%20scheme&width=600&height=500&seq=flanexus-hero-img&orientation=landscape"
                alt="炎禾智联数字化解决方案" 
                className="w-full rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Industry Growth Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">助力多行业企业成长</h2>
          </div>
          
          <div className="relative">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-8">
                <div className="space-y-6">
                  <div className="inline-flex items-center px-4 py-2 bg-orange-100 rounded-full">
                    <span className="text-orange-600 font-semibold">零售电商</span>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900">面向全球的零售数字化转型</h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    面对业务数字化的必然趋势，许多零售企业已经或正在进行数字化技术布局，以支撑企业的数字化转型需要。但从传统零售向数字化零售转型的过程中，企业仍然面对许多亟待解决的问题。
                  </p>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    炎禾智联具备丰富的零售企业数字化转型成功案例，提供包括品牌DTC平台搭建、数字化营销、会员管理、订单和商品管理等在内的全套解决方案。
                  </p>
                  <button className="inline-flex items-center text-orange-600 hover:text-orange-7 00 font-semibold">
                    探索更多
                    <i className="ri-arrow-right-line ml-2"></i>
                  </button>
                </div>
              </div>
              
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20retail%20digital%20transformation%20illustration%2C%20e-commerce%20platform%20interface%2C%20global%20retail%20technology%2C%20professional%20business%20graphics%20showing%20online%20shopping%2C%20digital%20marketing%2C%20customer%20data%20management%2C%20clean%20corporate%20design&width=600&height=400&seq=flanexus-retail&orientation=landscape"
                  alt="零售数字化转型" 
                  className="w-full rounded-2xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">我们的产品</h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-global-line",
                title: "品牌出海咨询",
                tag: "咨询服务",
                features: ["深度市场分析与策略制定", "个性化出海路径规划", "本土化运营指导"],
                link: "#"
              },
              {
                icon: "ri-shopping-cart-line",
                title: "D2C电商系统",
                tag: "电商平台",
                features: ["品牌DTC商城搭建", "私域运营平台", "全球化电商业务部署"],
                link: "#"
              },
              {
                icon: "ri-settings-3-line",
                title: "全渠道 OMS 系统",
                tag: "订单管理",
                features: ["统一订单管理", "多渠道库存同步", "智能履约优化"],
                link: "#"
              },
              {
                icon: "ri-bar-chart-line",
                title: "数据分析平台",
                tag: "数据洞察",
                features: ["实时数据监控", "精准用户画像", "业务增长分析"],
                link: "#"
              },
              {
                icon: "ri-customer-service-line",
                title: "本土化服务",
                tag: "本地化",
                features: ["文化适应性分析", "本土化运营支持", "当地合规指导"],
                link: "#"
              },
              {
                icon: "ri-rocket-line",
                title: "数字营销",
                tag: "营销推广",
                features: ["全方位营销策略", "品牌知名度提升", "ROI 优化管理"],
                link: "#"
              }
            ].map((product, index) => (
              <div key={index} className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border hover:border-orange-200">
                <div className="flex items-start justify-between mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className={`${product.icon} text-white text-2xl`}></i>
                  </div>
                  <span className="px-3 py-1 bg-orange-100 text-orange-600 text-sm font-medium rounded-full">
                    {product.tag}
                  </span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-orange-600 transition-colors">
                  {product.title}
                </h3>
                
                <div className="space-y-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-gray-600">
                      <span className="w-1.5 h-1.5 bg-orange-500 rounded-full mr-3"></span>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries We Serve Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">我们服务的行业</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              专注于为不同行业的全球品牌提供专业的出海扩张解决方案
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mb-16">
            {[
              {
                icon: "ri-store-line",
                title: "零售",
                description: "全渠道零售解决方案，助力传统零售品牌数字化转型"
              },
              {
                icon: "ri-magic-line", 
                title: "美妆",
                description: "美妆品牌本土化营销策略，精准触达目标消费群体"
              },
              {
                icon: "ri-shirt-line",
                title: "时尚",
                description: "时尚品牌全球扩张，打造国际化品牌形象"
              },
              {
                icon: "ri-t-shirt-line",
                title: "服饰",
                description: "服饰品牌出海运营，建立完整的供应链体系"
              },
              {
                icon: "ri-bear-smile-line",
                title: "母婴",
                description: "母婴产品安全合规，建立消费者信任与品牌忠诚度"
              }
            ].map((industry, index) => (
              <div key={index} className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border hover:border-orange-200 text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-orange-100 to-red-100 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform mb-6 mx-auto">
                  <i className={`${industry.icon} text-orange-600 text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-orange-600 transition-colors">
                  {industry.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Growth Data Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">与炎禾智联一起快速成长</h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <img 
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAilBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////2N2iNAAAALXRSTlMAj6ZnoBFFS3PqCseWLhuD9uVTIgT7h2so7q94NdbL3rxgXT0dCNnYsH0Ufm2Ro2j6AAABsklEQVR42u3WyXKCUBCF4SYBNIrmgkwyaJwSNen3f72glRQBbgoX3mbh+bZUUf/i0AUBAAAAwB2k+VStv2ggRVzyVU7yQtfz+dcLCZsE9pL/mpAgZ5sprgkHzJO3iGvCAWm+4pp0QBF/cEekBALqybdEb8n8yWxAPfkOlW2d6qHxAGeTKe5Y2sGBKqYD9trJ+54bUkUbYHzyZVxQxXjAXDd5XuUpVQQCiqV28lSRCZh2Jr+5TF4s4BC1Jn95v2SAo5+8fMB7Y/LyAU/UIB9gIwABtwe8/KvMQ8MBvbyhA3gxdIA7dMDoEQLKqc5aLsAlnWcEIAABCEAAAhBwr4DA8pqsQDQg465MMGDDOlu5AJt1bLkAi3ViuYCF4q7lQnCEu3duK3eyd+A8bzo/2iFCAAIQMHiAe3ptOu1EA2zu8gQDAtYJhv4f8OQCPNax5AJmirtUKjjCkc9t/kj0MwzTWVMaPtghQgACEIAABCAAAYIBh8VFwVercb8VX1nPOj91yezCoRt8KjYmikPqM2ajxtTHZ6N86qPYKEV9jmzUkfrs12zQek+9JollTDIhAAAAgLZvaSHLU9A65hoAAAAASUVORK5CYII="
                  alt="品牌和商家" 
                  className="w-10 h-10"
                />
              </div>
              <div className="text-5xl font-bold text-orange-400 mb-2">20+</div>
              <div className="text-gray-300">服务品牌</div>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <img 
                  src="https://gtechdigi.cn/_nuxt/img/data_icon2.5abaa75.png"
                  alt="东南亚经验" 
                  className="w-10 h-10"
                />
              </div>
              <div className="text-5xl font-bold text-orange-400 mb-2">8+</div>
              <div className="text-gray-300">年东南亚经验</div>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <img 
                  src="https://gtechdigi.cn/_nuxt/img/data_icon3.09f1aa6.png" 
                  alt="行业经验" 
                  className="w-10 h-10"
                />
              </div>
              <div className="text-5xl font-bold text-orange-400 mb-2">10+</div>
              <div className="text-gray-300">年行业经验</div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-6 py-16">
          {/* Bottom Footer */}
          <div className="border-t border-gray-800 pt-8">
            <div className="flex justify-center items-center">
              <div className="flex items-center space-x-2 text-sm text-gray-400">
                <i className="ri-robot-line w-4 h-4 flex items-center justify-center"></i>
                <span>Powered by AI</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Flanexus;
